'use client';

import { useEffect, useState } from "react";
import styles from "./ContactModal.module.css";

export default function ContactModal({ name, isOpen, onClose }) {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        message: "",
    });

    // Fermer si clic en dehors du formulaire
    useEffect(() => {
        const handleClickOutside = (event) => {
            const modal = document.getElementById("contact-modal");
            if (isOpen && modal && !modal.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validation simple
        if (!formData.firstName || !formData.lastName || !formData.email || !formData.message) {
            alert("Veuillez remplir tous les champs avant de soumettre.");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            alert("Veuillez entrer une adresse email valide.");
            return;
        }

        // ✅ Si tout est bon
        console.log("Formulaire soumis :");
        console.log("Prénom :", formData.firstName);
        console.log("Nom :", formData.lastName);
        console.log("Email :", formData.email);
        console.log("Message :", formData.message);

        // Réinitialiser et fermer la modale
        setFormData({ firstName: "", lastName: "", email: "", message: "" });
        onClose();
    };

    return (
        <div className={styles.overlay}>
            <div className={styles.modal} id="contact-modal">
                <button className={styles.closeButton} onClick={onClose}>×</button>
                <h2>Contactez-moi<br />{name}</h2>

                <form className={styles.form} onSubmit={handleSubmit}>
                    <label htmlFor="firstName">Prénom</label>
                    <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="lastName">Nom</label>
                    <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="email">Email</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="message">Votre message</label>
                    <textarea
                        id="message"
                        name="message"
                        rows="4"
                        value={formData.message}
                        onChange={handleChange}
                        required
                    ></textarea>

                    <button type="submit" className={styles.submitButton}>
                        Envoyer
                    </button>
                </form>
            </div>
        </div>
    );
}
